import { ControllerRenderProps } from 'react-hook-form';
import { Box, Grid, useRadioGroup } from '@chakra-ui/react';

import Text from 'components/_core/Text';
import { PICKABLE_ILLUSTRATIONS } from 'components/BankAccountIcon/constants';
import DetailSidebar from 'components/DetailSidebar';

import locales from '../../locales';
import IllustrationRadioCard from '../IllustrationRadioCard';

export type IllustrationNameField = ControllerRenderProps<
  {
    illustrationName: string;
    name: string;
  },
  'illustrationName'
>;

interface IllustrationPickerSidebarProps {
  closeSidebar: () => void;
  field: IllustrationNameField;
}

const IllustrationPickerSidebar = ({
  closeSidebar,
  field,
}: IllustrationPickerSidebarProps) => {
  const { getRadioProps, getRootProps } = useRadioGroup(field);

  return (
    <DetailSidebar
      bg="white"
      bottom={0}
      onClose={closeSidebar}
      position="absolute"
      right={0}
      top={0}
      variant="ghost"
      width={360}
      zIndex={1}
    >
      <DetailSidebar.Header />
      <DetailSidebar.Body overflow="hidden" position="sticky">
        <Text fontSize="font-18" fontWeight="weight-500" variant="primary">
          {locales.title}
        </Text>
        <Box
          marginTop="space-16"
          overflow="scroll"
          paddingBottom="space-24"
          position="sticky"
        >
          <Grid {...getRootProps()} gap={12} templateColumns="repeat(2, 1fr)">
            {PICKABLE_ILLUSTRATIONS.map((illustrationName) => {
              const radio = getRadioProps({ value: illustrationName });
              return (
                <IllustrationRadioCard
                  key={illustrationName}
                  {...radio}
                  value={illustrationName}
                />
              );
            })}
          </Grid>
        </Box>
      </DetailSidebar.Body>
    </DetailSidebar>
  );
};

export default IllustrationPickerSidebar;
